import { Box } from '@mui/system';
import { GridApi, GridReadyEvent } from 'ag-grid-community';
import { BudgetBys, BudgetExpenseOrIncome } from 'business/constants';
import ExportButton from 'components/ExportButton/ExportButton';
import GeneralModal from 'components/SharedComponents/Modals/GeneralModal';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { getInscriptionsHistoryModalColDefs } from 'routes/BudgetModule/components/BudgetOverview/AllInscriptions/helpers/inscriptionsHistoryGridColDef';
import useGetInscriptionsHistory from 'routes/BudgetModule/components/BudgetOverview/AllInscriptions/hooks/useGetInscriptionsHistory';
import { sideBar } from 'routes/BudgetModule/components/BudgetProposal/Resource/ExpenseIncome/gridHelpers/gridHelpers';
import SeeDetailsCellRenderer from 'routes/BudgetModule/components/shared/InscriptionsGrid/cellRenderers/SeeDetailsCellRenderer';
import AgGrid from 'ui/AgGridReact/AgGridReact';
import Flex from 'ui/Flex/Flex';

type Props = {
    isOpen: boolean;
    onClose: () => void;
    title: string;
    exercice: number;
    budgetName: string;
    budgetProposalBy: BudgetBys;
    expenseOrIncome: BudgetExpenseOrIncome;
};

const InscriptionsHistoryModal = (props: Props): React.ReactElement => {
    const {
        isOpen,
        onClose,
        title,
        exercice,
        budgetName,
        budgetProposalBy,
        expenseOrIncome,
    } = props;
    const gridApiRef = React.useRef<GridApi | null>(null);
    const [gridApi, setGridApi] = React.useState<GridApi | null>(null);
    const { t } = useTranslation();
    const closeButton = {
        text: t('common.close'),
        onClick: onClose,
    };
    const colDefs = getInscriptionsHistoryModalColDefs(budgetProposalBy);
    const { data = [] } = useGetInscriptionsHistory(
        exercice,
        budgetName,
        isOpen,
        expenseOrIncome,
    );
    const exportOptions = {
        allColumns: true,
        fileName: title,
        sheetName: t('allInscriptions.openHistory'),
    };
    const onGridReady = useCallback((event: GridReadyEvent) => {
        gridApiRef.current = event.api;
        setGridApi(event.api);
    }, []);
    return (
        <GeneralModal
            isOpen={isOpen}
            onClose={onClose}
            title={title}
            width="xl"
            showCloseButton
            containedButton={closeButton}
            shouldCloseOnBackdropClick
        >
            <Flex justifyContent="right">
                <ExportButton exportOptions={exportOptions} gridApi={gridApi} />
            </Flex>
            <Box className="ag-theme-material">
                <AgGrid
                    rowData={data}
                    columnDefs={colDefs}
                    domLayout="autoHeight"
                    rowHeight={36}
                    rowGroupPanelShow="always"
                    pagination
                    paginationPageSize={100}
                    components={{
                        seeDetailsCellRenderer: SeeDetailsCellRenderer,
                    }}
                    sideBar={sideBar}
                    onGridReady={onGridReady}
                />
            </Box>
        </GeneralModal>
    );
};

export default InscriptionsHistoryModal;
